import { CheckCircle, Server, XCircle } from 'lucide-react'
import { useTestConnection } from '@/hooks/use-settings'

interface EngineConnectionCardProps {
  engineUrl: string
  isHealthy: boolean
}

export function EngineConnectionCard({
  engineUrl,
  isHealthy,
}: EngineConnectionCardProps): React.JSX.Element {
  const testConnection = useTestConnection()

  const statusText = testConnection.isSuccess
    ? testConnection.data.ok
      ? 'Connection successful'
      : 'Connection failed'
    : null

  return (
    <div className="rounded-xl border border-surface-3 bg-surface-0 p-6">
      <div className="mb-4 flex items-center gap-2">
        <Server className="h-5 w-5 text-admin-500" />
        <h2 className="text-sm font-medium text-text-primary">SMTP Engine Connection</h2>
      </div>
      <div className="space-y-3">
        <div>
          <p className="text-xs font-medium text-text-secondary">Engine URL</p>
          <p className="mt-0.5 font-mono text-sm text-text-primary">{engineUrl}</p>
        </div>
        <div className="flex items-center gap-2">
          <p className="text-xs font-medium text-text-secondary">Health Status</p>
          {isHealthy ? (
            <span className="inline-flex items-center gap-1 text-xs font-medium text-green-600">
              <CheckCircle className="h-3.5 w-3.5" /> Healthy
            </span>
          ) : (
            <span className="inline-flex items-center gap-1 text-xs font-medium text-red-600">
              <XCircle className="h-3.5 w-3.5" /> Degraded
            </span>
          )}
        </div>
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => testConnection.mutate()}
            disabled={testConnection.isPending}
            className="rounded-lg border border-surface-3 px-3 py-1.5 text-sm font-medium text-text-primary hover:bg-surface-2 disabled:opacity-50"
          >
            {testConnection.isPending ? 'Testing...' : 'Test Connection'}
          </button>
          {statusText && (
            <span
              className={
                testConnection.data?.ok ? 'text-xs text-green-600' : 'text-xs text-red-600'
              }
            >
              {statusText}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
